import { useState } from "react";
import classNames from "classnames";
import Link from "next/link";

import { GLOSSARY_ALPHABET as alphabet } from "constants/glossary";

import SolidArrowIcon from "components/Icons/arrows/SolidArrowIcon";

const GlossaryNavigation = ({ currentLetter = "" }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        className="md:hidden flex justify-between w-full p-sm bg-leafly-white border border-light-grey mb-xl"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select a letter"
      >
        <span>Select a letter</span>
        <SolidArrowIcon
          height="24"
          width="24"
          direction={isOpen ? "up" : "down"}
        />
      </button>
      <ul
        className={classNames(
          "max-h-[270px] overflow-y-auto justify-center z-[2] w-full mb-xl absolute md:relative block md:flex shadow md:shadow-none bg-white md:bg-leafly-white -mt-xl md:mt-lg",
          {
            "h-0 md:h-auto": !isOpen,
            "h-auto py-sm md:py-0": isOpen,
          },
        )}
      >
        {alphabet.map((letter) => (
          <li key={`glossary-nav-${letter}`}>
            <Link
              href={`/learn/cannabis-glossary?letter=${letter}`}
              className={classNames(
                "block uppercase py-sm text-sm md:text-md px-lg md:px-xs lg:px-sm hover:md:text-green",
                {
                  "md:text-green font-bold ": currentLetter === letter,
                },
              )}
            >
              {letter === "special" ? "#" : letter}
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
};

export default GlossaryNavigation;
